import React from 'react'
import Permission from '../../../../utilities/auth/permission/Permission'

import { PermissionProvider, AuthTokenProvider } from '../auth'
import { AppLocationProvider } from './AppLocationProvider'
import { SnackbarProvider } from './SnackbarProvider'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

interface roleProp {
  id: number
  value: string
}

interface wrapProps {
  permission: Permission
  role: roleProp
}

export function wrap({ permission, role, children }: React.PropsWithChildren<wrapProps>) {
  return (
    // <SnackbarProvider>
    <QueryClientProvider client={queryClient}>
      <AppLocationProvider>
        <AuthTokenProvider>
          <PermissionProvider permission={permission} role={role}>
            {children}
          </PermissionProvider>
        </AuthTokenProvider>
      </AppLocationProvider>
    </QueryClientProvider>
    // </SnackbarProvider>
  )
}
